module.exports = __webpack_public_path__ + "static/media/ndi-insert.e6b35828.pdf";